import webapi from '../../api/webapi'
import item from './item'
import moment from 'moment'
/**
   通常設定
*/

const state = {
  cart_items:[],
  cart_page_visible: false,
  last_order_time:[],
}

const getters = {
  CartVisible: state=>{
    if(state.cart_items.length==0){
      return false
    }else{
      return true
    }
  },
  CartItemCount: state=>{
    
    return state.cart_items.length
  },
  CartItems: state=> state.cart_items,
  CartPageVisible: state=> state.cart_page_visible,


  //商品の残数をチェックする(残数なし→true) 
  CheckLimitCount: state=>(item,order_zan, is_cart_check)=>{
    var order_count=item.count
    //カート内の同一商品の数も計算する
    if(is_cart_check){
      state.cart_items.forEach(function(cart){
        if(Number(cart.code)==Number(item.item_info.Goods)){
          order_count+=cart.count
        }
      })
    }
    

    if(Number(order_zan)>0){
      //Max注文数をチェック
      return Number(order_zan)-order_count
    }else{
      return 999
    }
  },
  //提供タイプから商品の残数をチェックする(残数なし→true)
  CheckRequestLimitCount: state=>(requests,parent, is_cart_check)=>{
    if(Number(parent.OrderZan)>0){
      //Max注文数をチェック
      var request_count=0
      requests.forEach(function(item){
        request_count+=item.request_count
      })

      //カート内の同一商品の数も計算する
      if(is_cart_check){
        state.cart_items.forEach(function(cart){
          if(Number(cart.code)==Number(parent.Goods)){
            cart.request.forEach(function(req){
              request_count+=req.request_count
            })
          }
        })
      }
      
      return Number(parent.OrderZan)-Number(request_count)
    }else{
      return 999
    }
  },

  //構成品のLimitをチェックする
  CheckCategoryLimitCount: state=>(category,count)=>{
    //if(category.select_mode==1){
      return Number(category.limit_count)<=Number(count)
    //}else{
    //  return false
    //}
  },

  //放題メニューのSendLimitをチェックする（差分がマイナスの場合はLimitオーバー）
  CheckSubmenuSendLimit: state =>(submenu, count)=>{
    //カートの中身も合わせて放題商品のLimitをチェックする
    if(submenu==null){
      return 999
    }
    var order_count=count
    state.cart_items.forEach(function(cart){
      if(Number(cart.submenu_code)==Number(submenu.Goods)){
        order_count+=cart.count
      }
    })
    
    if(submenu.SendLimit==0){
      return 999
    }else{
      return Number(submenu.SendLimit)-order_count
    }
  },

  //放題メニューのLockTimeをチェックする(オーダー可能=true)
  CheckSubmenuLockTime: state =>(submenu)=>{
    //カートの中身も合わせて放題商品のLimitをチェックする
    
    if(submenu==null){
      return true
    }
    var past_secound=99999
    state.last_order_time.forEach(function(item){
      if(Number(item.code)==Number(submenu.Goods)){
        //最終オーダー時間から現在時刻までの分を計算する
        past_secound=moment().diff(item.time,'seconds')
      }
    })
    
    if(Number(submenu.LockTime)==0){
      return true
    }else{
      return past_secound>=Number(submenu.LockTime)*60
    }
  },

  //カートの中にある放題メニューのLockTimeをチェックする(オーダー可能=true)
  CheckCartLockTime: state =>(submenu)=>{
    //カートの中身も合わせて放題商品のLimitをチェックする
    if(submenu==null){
      return true
    }
    //カートに放題メニューがなければスルー
    var isExist=false
    state.cart_items.forEach(function(cart){
      if(Number(cart.submenu_code)==Number(submenu.Goods)){
        isExist=true
      }
    })

    if(isExist){
      var past_secound=99999
      state.last_order_time.forEach(function(item){
        if(Number(item.code)==Number(submenu.Goods)){
          //最終オーダー時間から現在時刻までの分を計算する
          past_secound=moment().diff(item.time,'seconds')
        }
      })
      
      if(Number(submenu.LockTime)==0){
        return true
      }else{
        return past_secound>=Number(submenu.LockTime)*60
      }
    }else{
      return true
    }
    
  },
  
  /**
    カートの中に制限時間のすぎた放題メニューがあるかチェックする
  */
  CheckSubmenuEndtime: state =>(submenu)=>{
    var result=true
    state.cart_items.forEach(function(cart_item){
        if(submenu.Goods==cart_item.submenu_code){
          //終了時間をチェックする
          if(submenu.LimitEnd!='0'){
            var endtime=moment(moment().format('YYYYMMDD')+submenu.LimitEnd,'YYYYMMDDHHmmss')
            if(moment()>endtime){
              result=false
            }
          }
        }
    })
    return result
  },

  /**
    指定した放題メニューが時間内かチェックする
  */
 CheckTheSubmenuEndtime: state =>(submenu)=>{
  var result=true
  if(submenu.LimitEnd!='0'){
    var endtime=moment(moment().format('YYYYMMDD')+submenu.LimitEnd,'YYYYMMDDHHmmss')
    if(moment()>endtime){
      result=false
    }
  }
  
  return result
},


}

// actions
const actions = {
  /**
    カートにオーダー商品を追加する
  */
  AddCartItem({ commit,dispatch,getters}, order) {
    //commit('addCartItems', order)
    var cart_item={
      submenu_code: order.submenu_code, //放題商品の場合にセット
      item_info: order.item_info,
      name: order.item_info.GoodsName,
      code:  order.item_info.Goods,
      count:  order.count,
      request_count: 0,
      category_count: 0,
      request:[],
      category_list:[],
    }
    //提供リクエストあり
    var req_index=0
    order.request.forEach(function(req){
      if(req.request_name!='' && req.request_name!=undefined){
        req_index++
        cart_item.request.push({ 
          name:   req.request_name, 
          request_count:  req.request_count})
      }
    })
    cart_item.request_count=req_index
    
    //構成品あり
    cart_item.category_list=order.category
    cart_item.category_count=order.category.length
    /*
    order.category.category_item.forEach(function(cate){
      cate_index++
      
      cart_item.category.push({ 
        code:   cate.code, 
        name:   cate.name, 
        count:  cate.count})
    })
    cart_item.select_mode=order.category.select_mode
    cart_item.last_count=order.category.last_count
    cart_item.category_name=order.category.category_name
    cart_item.category_count=cate_index

    */
    
    commit('addCartItems', cart_item)
    dispatch('saveCartData', getters.CartItems)
  },
  SetCartPageVisible({commit,dispatch}, visibility){
    if(visibility){
      dispatch('ClearPageTimer')
    }else{
      dispatch('SetPageTimer')
    }
    commit('cartPageVisible', visibility)
  },
  ClearCartItems({commit}){
    commit('clearCart')
  },

  //Localのカートデータを変換してセットする
  SetCartSavedData({commit,dispatch}, json_str){
    try{
      if(json_str!=''){
        commit('updateCartData' ,JSON.parse(json_str))
      }
        
    }catch(e){
      dispatch('showErrorMessage', 'カートデータの変換時にエラーが発生しました')
    }
    
  },
  //カートの注文数をチェックする
  //OrderZan>0 の時、上限チェックする
  //OrderStatus=2 or 7 の時はオーダー不可
  //SendLimit>0 の場合、上限数チェックする
  CheckCartItemCount({},param){
    if(param.count<0){
      param.count=0
    }
    if(isNaN(param.count)){
      param.count=0
    }
    /*
    if(param.parent.OrderZan!=0){
      if(param.parent.SendLimit<param.count)
        param.count=param.parent.SendLimit
    }
    */
    //param.item.order_count=param.count
    param.item.count=param.count
  },
  //カートのリクエスト数をチェックする
  //SendLimit>0 の場合、上限数チェックする
  CheckCartItemRequestCount({}, param){
    if(isNaN(param.count)){
      param.count=0
    }
    if(Number(param.count)<0){
      param.count=0
    }
    
    param.item.request_count=param.count

    var order=0
    param.req_parent.forEach(function(item){
      if(item.request_name!='')
        order=order+Number(item.request_count)
    })
    param.parent.count=order
      

    
  },
  
  //カートの構成品数をチェックする
  //SelectMode = 1 :指定された数を必須選択
  //LimitCount>0 の場合、上限数チェックする。SelectMode = 1の場合、この数までチェック必須
  CheckCartCategoryItemCount({dispach},param){
    if(isNaN(param.count)){
      param.count=0
    }
    if(Number(param.count)<0){
      param.count=0
    }
    //構成品の合計数を計算
    var cateCount=0
    var CateLimit=0
    param.parent.ConfigLists.ConfigList.forEach(function(config){
      CateLimit=+config.LimitCount*param.cate_parent.count
    })
    
    param.items.forEach(function(cate){
      if(param.item.code==cate.code)
        cateCount+=param.count
      else
        cateCount+=cate.count
    })
    if(param.parent.ConfigLists.ConfigList.SelectMode=='0'){
      if(param.parent.ConfigLists.ConfigList.LimitCount<cateCount)
        return
    }
    if(param.parent.ConfigLists.ConfigList.SelectMode=='1'){
      if(CateLimit<cateCount){
        //dispatch('showErrorMessage', param.parent.CategoryLists.CategoryList.CategoryName+'は'+param.parent.CategoryLists.CategoryList.LimitCount+'つ選んでください')
        return
      }
    }
    param.item.count=param.count
  },

  /*
    放題メニュー毎に、最後にオーダーされた時刻を保存する
  */
  SetLastOrderTime({commit},param){
    commit('updateLastOrderTime',param)
  }
}

// mutations
const mutations = {
  addCartItems(state, item) {
    /**
     * 現在のカート
     * cart_items   追加商品単位
     *  |_ request        注文時リクエスト配列
     *  |_ category_list  構成品配列
     *        |_ configList   構成品配列(１商品に複数あり)
     *              |_  category_item   構成品
     *                      code
     *                      count
     *                      name
     * ==========================================
     * 追加する商品
     * item
     * |_ request        注文時リクエスト配列
     * |_ category_list  構成品配列
     *        |_ configList   構成品配列(１商品に複数あり)
     *              |_  category_item   構成品
     *                      code
     *                      count
     *                      name
     */
    var exist=false
    state.cart_items.forEach(function(cart){
      if(Number(cart.code)==Number(item.code) && Number(cart.submenu_code)==Number(item.submenu_code)){
        //上書き加算(商品コードと親商品コードで一意)
        exist=true
        cart.count+=item.count
        //リクエスト加算
        cart.request.forEach(function(req){
          item.request.forEach(function(item_req){
            if(req.name==item_req.name){
              req.request_count+=item_req.request_count
            }
          })
        })
        //構成品加算　もし同じ商品があったら、configListを追加する
        debugger
        if(item.code==cart.code){
          //cart.count+=item.count
          item.category_list.forEach(function(cate){
            cart.category_list.push(cate)
          })
          
        }
        /*
        cart.category.forEach(function(cate){
          debugger
          item.category.forEach(function(item_cate){
            debugger
            if(cate.code==item_cate.code){
              cate.count+=item_cate.count //既存の同商品の数に加算する
            }
          })
        })
        */
      }  
    })
    if(exist==false){
      //新規追加
      state.cart_items.push(item) 
    }
    
  },
  cartPageVisible(state, value) {
    state.cart_page_visible=value 
  },
  clearCart(state) {
    state.cart_items=[] 
  },
  updateCartData(state, json){
    if(Array.isArray(json)){
      state.cart_items=json
    }else{
      state.cart_items=[json]
    }
  },
  updateLastOrderTime(state, param){
    var isExist=false
    state.last_order_time.forEach(function(item){
      if(Number(item.code)==Number(param.code)){
        item.time=param.time //momentオブジェクト
        isExist=true
      }
    })
    if(isExist==false){
      state.last_order_time.push({
        code: param.code,
        time: param.time
      })
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js